import { ChakraProvider } from "@chakra-ui/react";
import React from "react";

export default function Providers({ children }) {
  return <ChakraProvider>{React.Children.toArray(children)}</ChakraProvider>;
}
